import React, { useState } from 'react';

import { DrawerComponent } from 'components/Drawer';
import * as S from './styles';
import { api } from 'services/api';
import { triggerBase64Download } from 'common-base64-downloader-react';
import moment from 'moment';
import { DownloadIcon } from 'components/Icons';
import Toast from 'components/Toast/Toast';

interface IDownloadFiscal {
  closeDrawer: () => void;
  onClose?: () => void;
  product: string;
  invoices: any;
}

type InvoiceEntity = {
  id_billing: string;
  id_invoice: string;
  emissionDate: string;
  id_netsuite: string;
  numberInvoice: string;
  status: string;
};
type ToastEntity = {
  message: string;
  type: 'success' | 'error' | 'warning';
};
const DownloadFiscal = ({
  product,
  invoices,
  closeDrawer,
}: IDownloadFiscal) => {
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [toast, setToast] = useState(false);
  const [dataForToast, setDataForToast] = useState<ToastEntity | undefined>(
    undefined,
  );

  const handleCloseToast = () => {
    setToast(false);
  };
  const fetchDataPlan = async ({ id_billing, id_invoice }: InvoiceEntity) => {
    try {
      const { data } = await api.get(
        `client/billings/${id_billing}/invoice/${id_invoice}`,
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setDataForToast({
        type: 'success',
        message: 'Nota baixada com sucesso.',
      });
      setToast(true);
      return data.data;
    } catch (error) {
      setDataForToast({
        type: 'success',
        message:
          'Tivemos um problema para baixar a nota. Tente novamente mais tarde.',
      });
      setToast(true);
      console.log(error);
    }
  };
  const handlerInvoicePDFDonwload = async (invoice: InvoiceEntity) => {
    const { numberInvoice } = invoice;
    const response = await fetchDataPlan(invoice);
    if (response) {
      return await triggerBase64Download(
        'data:application/pdf;base64,' + response,
        `${numberInvoice}-${product.toLowerCase()}`,
      );
    }
  };
  return (
    <>
      <DrawerComponent
        open
        size="default"
        // className={styles.drawer}
        onCompleteClose={closeDrawer}
        titleClose={'Notas Fiscais'}
      >
        <S.WrapperInvoiceDetail>
          <div>
            <p>{product}</p>
          </div>
        </S.WrapperInvoiceDetail>
        <S.Box>
          {invoices?.map(
            (invoice: InvoiceEntity, idx: number) =>
              invoice.status === 'emitida' && (
                <S.BoxDownload
                  key={idx}
                  onClick={() => handlerInvoicePDFDonwload(invoice)}
                >
                  <div>
                    <p>Nota Nº {invoice.numberInvoice}</p>
                    <span>
                      Emitida em {moment(invoice.emissionDate).format('L')}
                    </span>
                  </div>
                  <span style={{ alignContent: 'center' }}>
                    <DownloadIcon />
                  </span>
                </S.BoxDownload>
              ),
          )}
        </S.Box>
      </DrawerComponent>
      {toast && (
        <Toast
          type={dataForToast?.type || 'warning'}
          message={dataForToast?.message || ''}
          onClose={handleCloseToast}
        />
      )}
    </>
  );
};
export default DownloadFiscal;
